export { default } from './StandardCard';
export type { StandardCardProps } from './StandardCard';
